import { entitlementsService } from '@/services/entitlements-service.js';

export class HatElement extends HTMLElement {
    protected readonly root: ShadowRoot;
    private _unsubscribeEntitlements: (() => void) | null = null;

    constructor() {
        super();
        this.root = this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        entitlementsService.applyTo(this.root);
        this._unsubscribeEntitlements = entitlementsService.subscribe(() => {
            entitlementsService.applyTo(this.root);
        });
    }

    disconnectedCallback() {
        if (this._unsubscribeEntitlements) this._unsubscribeEntitlements();
    }

    protected _applyEntitlements() {
        entitlementsService.applyTo(this.root);
    }
}